// Argus — UrlMonitoringWindow: monitor URL-uri vizitate (browser history) — placeholder iter2 round 2.
// Pipeline complet (URL extraction din browsers + push agent → DB) implementat în iter3 dedicat.
// Pentru moment, placeholder cu form list + buton refresh + tabel placeholder.

import { Alert, Box, Button, Chip, Typography } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import RefreshIcon from '@mui/icons-material/Refresh';

export interface UrlMonitoringWindowProps {
  agentId: string;
  agentOnline: boolean;
}

export function UrlMonitoringWindow({ agentId, agentOnline }: UrlMonitoringWindowProps): JSX.Element {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 1.5, display: 'flex', alignItems: 'center', gap: 1, borderBottom: 1, borderColor: 'divider' }}>
        <LinkIcon color="primary" />
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>URL Monitoring</Typography>
        <Chip size="small" label="Coming soon" color="warning" variant="outlined" />
        <Box sx={{ flexGrow: 1 }} />
        <Button size="small" startIcon={<RefreshIcon />} disabled>Refresh</Button>
      </Box>
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2, flexGrow: 1, overflow: 'auto' }}>
        <Alert severity="info" variant="outlined">
          Browser URL history monitoring will be available in a future release. Pipeline planned:
          <ul style={{ margin: '8px 0 0 16px' }}>
            <li>Agent reads browser history (Chrome / Edge / Firefox SQLite + Brave / Opera profiles)</li>
            <li>Push to server periodically (every 5 minutes when changed)</li>
            <li>Operator filters by domain, time range, search keywords</li>
            <li>Compliance: justified per-session access only, audit log entry per query</li>
          </ul>
        </Alert>
        <Typography variant="caption" color="text.disabled">
          Agent: {agentId.substring(0, 16)}… · Online: {agentOnline ? 'yes' : 'no'}
        </Typography>
      </Box>
    </Box>
  );
}
